// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-vUr","textarea":"styles_textarea__1rtWJ"};